import { useDispatch } from "react-redux";
import { ErrorToast } from "../redux/actions/ToasterAction";

import { MoveClientModel } from "../models/FormDataModel";
import {useHierarchyService} from "./useHierarchyService";
import { useBedServices } from "./useBedServices";
import { useClientService } from "./useClientService";

import Services from "../service/ApiServices"

import { FormattedDateString,  GetDate } from "../utilities/DateHelper";
import { TreeNodeTypes } from "../constants/ProConstants";
import _ from 'lodash'



const useFormModelServices = ()=>{ 
   
   const {data:{currentLocation, parentsInHierarchy, parentTypes, parents, rooms}} =  useHierarchyService()
   const {bedStatuses, bedTypes} = useBedServices(); 
   const {GetClientAllergyDetails, GetClientMedicationDetails, GetClientBedHistory} = useClientService()

    const GetLevelType = (code)=>{
        var index = _.findIndex(TreeNodeTypes, (t)=>t.code === code);
        if(index >= 0){
            return TreeNodeTypes[index]
        }
        return {};
    }
    const dispatchFormModel = useDispatch();
    const GetSetupModel = async (node)=>{
        try{
            let model = {};              
            switch(node.type){
                case "BUILDING":               
                    model =  (await Services.Setup.getBuildingById(node.id)).data; //DummyBuilding01;               
                    break;
                case "BED":
                    model= (await Services.Setup.getBedById(node.id)).data; 
                    model = {...model, bedStatus: _.find(bedStatuses, (o)=>{return o.key === _.get(model.bedStatus,"key")}), bedType:_.find(bedTypes, (o)=>{return o.key === _.get(model.bedType, "key")})}
                    break;
                case "FLOOR":
                case "UNIT": 
                case "WING":
                case "ROOM":               
                    model = (await Services.Setup.getIntermediateById(node.type, node.id)).data //DummyFloor01;
                    break; 
                default:               
                    break;
            }
            return {type: GetLevelType(node.type), model: model};
        }
        catch(err){
            dispatchFormModel(ErrorToast('Error', _.get(err, 'response.data.message') || err));
        }     
    }

    const GetCensusModel = async (data, action)=>{
        try{
            let model = null;
            if(_.get(data, "assignmentId")){
                model = (await Services.Census.getBedAssignmentData(data.assignmentId)).data;           
                model = {...model, startDate:GetDate(model.startDate), endDate: GetDate(model.endDate)}
            
            }
            return model;
        }
        catch(err){
            dispatchFormModel(ErrorToast('Error', _.get(err, 'response.data.message') || err));
        }
    }

    const InitializeMoveClient = (model)=>{ 

            const buildingData =  _.find(parentsInHierarchy, (o) => { return o.type === "BUILDING"; })           
            const parentType = _.find(parentTypes, (o)=>{return o.key === parentsInHierarchy[1].type})
            const parent = _.intersectionBy(parentsInHierarchy, parents, 'key')      
            const room = _.intersectionBy(parentsInHierarchy, rooms, "key") 
          
            model = _.merge(model , {...MoveClientModel
                                     ,location:currentLocation
                                     ,building:buildingData
                                     ,parentType: parentType
                                     ,parent: parent.length===1? parent[0]: null
                                     ,room: room.length === 1? room[0]: null 
                                     ,bed: null})
            return model;
         }

   

    const GetDetails = async (node, date, assignmentData, action)=>{   
        try{      
            switch(action)
            {
                case "VIEW_BED":
                    return (await Services.Census.getBedDetailsByIdAndDate(node.id, {date: FormattedDateString(date)})).data
                case "BED_HISTORY":
                    return (await Services.Census.getBedOccupantHistory(node.id)).data
                case "CLIENT_HISTORY":
                return await GetClientBedHistory(assignmentData.client.id)
                case "CLIENT_ALLERGY":
                    return await GetClientAllergyDetails(assignmentData.client.id)
                case "CLIENT_MEDICATION":
                    return await GetClientMedicationDetails(assignmentData.client.id)               
                default:
                    return null;
            }
        }
        catch(err){
            dispatchFormModel(ErrorToast('Error', _.get(err, 'response.data.message') || err));
        }     
    }

    const GetWaitlistClient = async(assignmentId)=>{
        try{
            return (await Services.Waitlist.getWaitlistClientById(assignmentId)).data || {}
        }
        catch(err){
            dispatchFormModel(ErrorToast('Error', _.get(err, 'response.data.message') || err));
        }     
    }
    

    return {GetSetupModel, GetCensusModel, GetDetails, InitializeMoveClient , GetWaitlistClient};
}


export default useFormModelServices;